
import koMessages from '../locales/ko_KO';
const KoLang = {
    messages: {
        ...koMessages,
    },
    locale: 'ko-KO',

};
export default KoLang;
